import React, { useEffect, useState } from 'react';
import { Box, Fade, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddNewCustomer from '../../NewFigma/AddCustomer/AddNewCustomer.jsx';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useDispatch, useSelector } from 'react-redux';
import { updateTitle } from '../../../redux/reducers/titleSlice.js';
import { setCustomModalAction } from '../../../redux/reducers/controllNavigation.js';
import { set } from 'lodash';

const style = {
  position: 'absolute',
  right: '10%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  padding: '0px',
  overflow: 'hidden',
  height: '85%',
  width: '85%',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50% )',
};

function AddNewPartyModal(
  {
    open,
    setOpen,
    partyType,
    setNewPartyID,
    partyParamsID,
    Type,
    view,
    newPartyName,
    partyGroupId,
    page,
    setPartyType,
    listPartyDetails,
    passFn,
    setNewPartyName,
    accountId,
    onSave,
  } = {

    onSave: (accountsId, partyId) => {},
    open: false,
    setOpen: () => {},
    partyType: '',
    Type: '',
    setNewPartyID: () => {},
    setPartyType: () => {},
    partyGroupId: '',
    partyParamsID: '',
    page: '',
    partyId: '',
    newPartyName: '',
    accountId: 0,
    view: false,
    listPartyDetails: () => {},
    passFn: () => {},
    setNewPartyName: () => {},
  }
) {


  const dispatch = useDispatch();

  const controllModal = useSelector((state) => state.controllNavigationSlice);

  const [selectValue, setSelectValue] = useState('customer');

  const onClose= ()=>{
   
  }


  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    if (controllModal.isCheckModalBlocked && reason !== 'force') {
      dispatch(setCustomModalAction({ key: 'modalName', value: 'partyModal' }));
      dispatch(setCustomModalAction({ key: 'isModalOpen', value: true }));
      dispatch(setCustomModalAction({ key: 'onLeaveFunction', value: ()=> setOpen(false) }));
      return;
    }
    setOpen(false);
  };
  useEffect(() => {
    dispatch(updateTitle(newPartyName));
  }, []);

  console.log({ objects: Type, partyType ,partyParamsID,accountId , });
  return (
    <Modal
      id={open ? 'partyCreationModal' : ''}
      sx={{ width: '200px 200px' }}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={handleClose}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <Box
              sx={{
                backgroundColor: 'primary.main',
                padding: '5px 15px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {!partyParamsID && (accountId === 0 || !accountId)
                    ? page === 'DebitNote' || page === 'CreditNote'
                      ? selectValue === 'customer'
                        ? 'CUSTOMER'
                        : 'SUPPLIER'
                      : partyType === 'supplier'
                      ? 'Add Supplier'
                      : 'Add Customer'
                    : partyType === 'supplier'
                    ? newPartyName + '(Supplier)'
                    : newPartyName + ' (Customer)'}

                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: '#fff' }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>
            {(page === 'DebitNote' || page === 'CreditNote') && !partyParamsID ? (
              <FormControl sx={{ m: '15px' }}>
                <Typography
                  sx={{
                    color: 'primary.main',
                    fontSize: '15px',
                  }}
                >
                  Please select the party type{' '}
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  sx={{
                    m: 1,
                    '.css-1mvm44b-MuiTypography-root': {
                      color: 'primary.main',
                    },
                  }}
                >
                  <FormControlLabel
                    value={selectValue}
                    disabled={partyParamsID ? true : false}
                    control={<Radio />}
                    checked={selectValue === 'customer' ? true : false}
                    label="Customer"
                    color="primary.main"
                    onChange={(e) => {
                      setSelectValue('customer');
                    }}
                  />
                  <FormControlLabel
                    value={selectValue}
                    disabled={partyParamsID ? true : false}
                    color="primary.main"
                    control={<Radio />}
                    checked={selectValue === 'supplier' ? true : false}
                    label="Supplier"
                    onChange={(e) => {
                      setSelectValue('supplier');
                    }}
                  />
                </RadioGroup>
              </FormControl>
            ) : (
              ''
            )}
            <Box className="custom-scrollbar" sx={{ overflowY: 'scroll', flex: 1, padding: '10px' }}>
              <Box>
                <AddNewCustomer
                  view={view}
                  partyGroupId={partyGroupId}
                  partyType={(page === 'DebitNote' || page === 'CreditNote') && !partyParamsID ? selectValue : partyType}
                  closePartyModal={handleClose}
                  setNewPartyID={setNewPartyID}
                  partyParamsID={partyParamsID}
                  Type={Type}
                  newPartyName={newPartyName}
                  listPartyDetails={listPartyDetails}
                  passFn={passFn}
                  setNewPartyName={setNewPartyName}
                  onSave={onSave}
                  accountId={Number(accountId || 0)}
                  customModal={true}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default AddNewPartyModal;
